import React, { useEffect } from "react";
import { HeaderWrapper, HeaderTitle, SearchAndDropdownWrapper } from "./style";
import SearchBar from "./SearchBar";
import Dropdown from "./Dropdown";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { setQuestionList } from "@/redux/FaqsReducer";
import { mapQuestionList } from "./mapQuestionList";

function PageHeader() {
  const dispatch = useAppDispatch();
  const { showDropdown } = useAppSelector((state) => state.yogaFaqsReducer);

  useEffect(() => {
    dispatch(
      setQuestionList({
        questionsList: mapQuestionList(),
      })
    );
  }, []);

  return (
    <HeaderWrapper>
      <HeaderTitle variant="heading3">How can we help you today?</HeaderTitle>
      <SearchAndDropdownWrapper>
        <SearchBar />
        {showDropdown && <Dropdown />}
      </SearchAndDropdownWrapper>
    </HeaderWrapper>
  );
}

export default PageHeader;
